import React, { useState } from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setRuleValidErrorModalVisible } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import { IProps } from 'components/RuleValidErrorModal/types';
import Modal from 'components/Modal';
import { SweetAlertIcon } from 'constants/enums/sweetAlertIcon.enum';
import commonService from 'utils/commonService';

const RuleValidErrorModal : React.FC<IProps> = (props) => {
  /** 訊息位置 */
  const [msgIndex, setMsgIndex] = useState(0);
  /** 判斷是否讀完 */
  const [unReaded, setUnReaded] = useState(true);

  /**
   * @description 關閉 Modal
  */
  const handleClose = () => {
    if (props.modal.ruleValidErrorModalState.errorMsgs.length !== 1 && unReaded) return;
    setMsgIndex(0);
    setUnReaded(true);
    props.setRuleValidErrorModalVisible(false, new Array(0));
  };

  /**
   * @description 更新 Index
  */
  const handleReadMsg = (addIndex:number) => {
    const indexVal = msgIndex + addIndex;
    if (indexVal < 0 || indexVal > props.modal.ruleValidErrorModalState.errorMsgs.length - 1) return;
    if (indexVal === props.modal.ruleValidErrorModalState.errorMsgs.length - 1) {
      setUnReaded(false);
    }

    setMsgIndex(indexVal);
  };

  const handleFormatMsg = (msg:string) => {
    let formatMsg:any = msg;
    // if (/(,)(.*)/.test(msg)) {
    //   formatMsg = formatMsg.replace(/(,)(.*)/, '$2');
    // }

    // const a:string = '';
    if (typeof formatMsg === 'string' && formatMsg.startsWith(',')) {
      formatMsg = formatMsg.substring(1);
    }

    if (typeof formatMsg === 'string' && formatMsg.lastIndexOf(',') === formatMsg.length - 1) {
      formatMsg = formatMsg.substring(0, formatMsg.length - 1);
    }

    // if (/(.*)(,)/.test(msg)) {
    //   formatMsg = formatMsg.replace(/(.*)(,)/, '$1');
    // }

    // if (formatMsg.indexOf('<br />') !== -1) {
    //   const elementStr = formatMsg.split('<br />');

    //   formatMsg = _.map(elementStr, (str:string, index:number) => {
    //     return `${str}<br />`;
    //   });
    // }

    return formatMsg;
  };

  return (
    <>
      {props.modal.ruleValidErrorModalState.visible && (
        <Modal
          visible={props.modal.ruleValidErrorModalState.visible}
          icon={SweetAlertIcon.Info}
          title=""
          cancelButton={false}
          closeIcon={false}
          confirmButton={false}
        >
          <p className="modal__rule_error-msg">{commonService.htmlParser(handleFormatMsg(props.modal.ruleValidErrorModalState.errorMsgs[msgIndex]))}</p>
          <p className="modal__rule_error-pagination">{`${msgIndex + 1} / ${props.modal.ruleValidErrorModalState.errorMsgs.length}`}</p>
          <div className="modal__control">
            <button
              type="button"
              className={'modal__confirm-button' + (msgIndex === 0 ? ' modal__confirm-button__disable' : '')}
              disabled={msgIndex === 0}
              onClick={() => handleReadMsg(-1)}
            >
              上一則
            </button>
            <button
              type="button"
              className={'modal__confirm-button' + (msgIndex === props.modal.ruleValidErrorModalState.errorMsgs.length - 1 ? ' modal__confirm-button__disable' : '')}
              disabled={msgIndex === props.modal.ruleValidErrorModalState.errorMsgs.length - 1}
              onClick={() => handleReadMsg(1)}
            >
              下一則
            </button>
            <button
              type="button"
              className={'modal__confirm-button' + (props.modal.ruleValidErrorModalState.errorMsgs.length !== 1 && unReaded ? ' modal__confirm-button__disable' : '')}
              disabled={props.modal.ruleValidErrorModalState.errorMsgs.length !== 1 && unReaded}
              onClick={handleClose}
            >
              關閉
            </button>
          </div>
        </Modal>
      )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setRuleValidErrorModalVisible: (visible: boolean, errorMsgs:string[]) => dispatch(setRuleValidErrorModalVisible(visible, errorMsgs))
});

export default connect(mapStateToProps, mapDispatchToProps)(RuleValidErrorModal);
